import { DateRangePicker } from '@weberlo/components'

import useConfig from 'hooks/useConfig'
import { getMaxDate } from './getMaxDate'

const RangePicker = () => {
  // ConfigContext supplies the default range, so both dates are always set
  const { startDate, endDate, onChangeDate, timezone } = useConfig()

  return (
    <DateRangePicker
      startDate={new Date(startDate)}
      endDate={new Date(endDate)}
      onDateSelect={value => {
        onChangeDate(value.startDate!, value.endDate!)
      }}
      maxDate={getMaxDate(timezone)}
    />
  )
}

export default RangePicker
